import {
  DataVersion,
  GenerateIncidentReportPayload,
  IncidentProduct,
} from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useGenerateIncidentReport(
  product: IncidentProduct,
  onSuccess?: (file: File) => void,
  onError?: (err: Error) => void,
  dataVersion?: DataVersion
) {
  const searchParams = new URLSearchParams({ product });
  const request = new Request(
    `/v2/orm/location_incidents/incident-report?${searchParams.toString()}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    }
  );
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<File, GenerateIncidentReportPayload>(
    request,
    {
      onSuccess,
      onError,
      responseModifier: async (response) => {
        const blob = await response.blob();
        const fileName =
          response.headers.get('X-File-Name') || 'Incident_Report.pdf';
        return new File([blob], fileName, { type: 'application/pdf' });
      },
    }
  );
}

export default useGenerateIncidentReport;
